import React from 'react';
import { withRouter, NavLink, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';
import _ from 'lodash';
import { Classes } from '@blueprintjs/core';
import { styled } from '@moleculeone/ui';

import { isAuthenticated } from '@f/services/authentication/authentication.selectors';

import cls from './WelcomePage.module.css';

export const AbsolutePositionedContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

function WelcomePage({ shouldRedirectToDashboard }) {
  if (shouldRedirectToDashboard) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <AbsolutePositionedContainer>
      <div className={cls.textCenter}>
        <p className={cls.welcomeText}>Welcome to</p>
        <h1 className={cx(cls.mb200, cls.h1)}>
          <img src="/retroscore-logo-800.png" alt="M1 RetroScore powered by CAS" width="400" />
        </h1>

        <NavLink
          className={cx(cls.secondaryLink, Classes.BUTTON, Classes.LARGE, Classes.INTENT_PRIMARY)}
          to="/dashboard"
        >
          Sign in
        </NavLink>
      </div>
    </AbsolutePositionedContainer>
  );
}

export default _.flowRight([
  withRouter,
  connect(state => ({
    shouldRedirectToDashboard: state.authentication.processing <= 0 && isAuthenticated(state),
  })),
])(WelcomePage);
